import { StarSystem } from 'src/lib/systems/StarSystem';
import { PlanetSystem } from 'src/lib/systems/PlanetSystem';
var Scenario = /** @class */ (function () {
    function Scenario(data) {
        this.id = data.id;
        this.name = data.name;
        this.systemType = data.system.type;
        this.startDate = data.startDate;
        this.secondsPerTick = data.secondsPerTick;
        this.calcPerTick = data.calcPerTick;
        this.setSystem(data.system);
    }
    Scenario.prototype.getStartDate = function () {
        return this.startDate;
    };
    Scenario.prototype.getSecondsPerTick = function () {
        return this.secondsPerTick;
    };
    Scenario.prototype.getCalcPerTick = function () {
        return this.calcPerTick;
    };
    Scenario.prototype.getBodies = function () {
        if (!this.system) {
            throw new Error('There is no system in this Scenario! : Scenario::getBodies');
        }
        if (this.system.type === 'starsystem') {
            var system = this.system;
            var bodies = {
                center: system.getCenterBody(),
                others: system.getPlanetBodies(),
                type: system.type
            };
            return bodies;
        }
        else if (this.system.type === 'planetsystem') {
            var system = this.system;
            var bodies = {
                center: system.getCenterBody(),
                others: system.getMoonBodies(),
                type: system.type
            };
            return bodies;
        }
        else {
            throw new Error('invalid system type: Scenario::getBodies');
        }
    };
    Scenario.prototype.getAstronomicalObjects = function () {
        if (!this.system) {
            throw new Error('There is no system in this Scenario! : Scenario::getBodies');
        }
        var system = this.system;
        if (this.system.type === 'starsystem') {
            system = system;
            var objects = {
                center: system.getCenter(),
                others: system.getPlanets(),
                type: system.type
            };
            return objects;
        }
        else if (this.system.type === 'planetsystem') {
            system = system;
            var objects = {
                center: system.getCenter(),
                others: system.getMoons(),
                type: system.type
            };
            return objects;
        }
        else {
            throw new Error('invalid system type: Scenario::getAstronomicalObjects');
        }
    };
    Scenario.prototype.setSystem = function (system) {
        if (system.type === 'starsystem') {
            this.system = new StarSystem(system);
            this.system.setPlanetsPosition();
        }
        else if (system.type === 'planetsystem') {
            this.system = new PlanetSystem(system);
            this.system.setMoonsPosition();
        }
        else {
            throw new Error('Please check your scenario type: Scenario Class');
        }
    };
    return Scenario;
}());
export { Scenario };
